import React, { useState, useEffect } from 'react';
import ReactMarkdown from 'react-markdown';
import { CommonHash } from 'app/types';
import MDEditor from '@uiw/react-md-editor';

import styles from '../LandingForm.module.scss';
import rehypeRaw from 'rehype-raw';

interface ComponentFormProps {
  landing_cmp: CommonHash;
  handleChange: {
    (e: React.ChangeEvent<any>): void;
    <T = string | React.ChangeEvent<any>>(field: T): T extends React.ChangeEvent<any>
      ? void
      : (e: string | React.ChangeEvent<any>) => void;
  };
  index: number;
}

const MarkdownForm = ({
  landing_cmp,
  handleChange,
  index,
}: ComponentFormProps): React.ReactElement => {
  const [markdownText, setMarkdownText] = useState(landing_cmp.config?.description || '');
  useEffect(() => {
    handleChange({
      target: {
        name: `landing_components[${index}].config['description']`,
        value: markdownText,
      },
    });
  }, [markdownText]);
  return (
    <>
      <div className={styles.group}>
        <label htmlFor={`landing_components[${index}].config['title']`}>Title</label>
        <input
          name={`landing_components[${index}].config['title']`}
          placeholder="Title"
          onChange={handleChange}
          value={landing_cmp.config.title || ''}
        />
      </div>
      <div className={styles.group}>
        <label htmlFor={`landing_components[${index}].config['title_color']`}>Title color</label>
        <input
          name={`landing_components[${index}].config['title_color']`}
          placeholder="Title color"
          onChange={handleChange}
          value={landing_cmp.config['title_color'] || ''}
        />
      </div>
      <div className={styles.group}>
        <label htmlFor={`landing_components[${index}].config['title_size']`}>Title size</label>
        <select
          name={`landing_components[${index}].config['title_size']`}
          onChange={handleChange}
          value={landing_cmp.config ? landing_cmp.config['title_size'] : 'normal'}
        >
          <option value="large">Large</option>
          <option value="normal">Normal</option>
          <option value="small">Small</option>
        </select>
      </div>
      <div className={styles.group}>
        <label htmlFor={`landing_components[${index}].config['section_title']`}>
          Section title
        </label>
        <input
          name={`landing_components[${index}].config['section_title']`}
          placeholder="Section title"
          onChange={handleChange}
          value={landing_cmp.config['section_title'] || ''}
        />
      </div>
      <div className={styles.group}>
        <label htmlFor={`landing_components[${index}].config['section_title_color']`}>
          Section title color
        </label>
        <input
          name={`landing_components[${index}].config['section_title_color']`}
          placeholder="Section title color"
          onChange={handleChange}
          value={landing_cmp.config['section_title_color'] || ''}
        />
      </div>
      <div className={styles.group}>
        <label htmlFor={`landing_components[${index}].config['description']`}>Markdown Text</label>
        <MDEditor value={markdownText} onChange={setMarkdownText} />
        <ReactMarkdown rehypePlugins={[rehypeRaw]}>{markdownText}</ReactMarkdown>
      </div>
      <div className={styles.group}>
        <label htmlFor={`landing_components[${index}].config['description_color']`}>
          Markdown Text color
        </label>
        <input
          name={`landing_components[${index}].config['description_color']`}
          placeholder="Description color"
          onChange={handleChange}
          value={landing_cmp.config?.description_color || ''}
        />
      </div>
    </>
  );
};

export default MarkdownForm;
